import {Component, Input, inject, ViewEncapsulation} from '@angular/core';
import {NavigationService} from 'src/app/data/services/navigation.service';
import {ExternalOffer} from '../../../data/models/external-offer.model';
import {NgbCarousel, NgbSlide} from "@ng-bootstrap/ng-bootstrap";
import { NgOptimizedImage } from "@angular/common";
import {ImageService} from '../../services/image.service';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.css'],
  imports: [
    NgbCarousel,
    NgbSlide,
    NgOptimizedImage
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class ImageSliderComponent {
  navigationService = inject(NavigationService);
  imageService = inject(ImageService);

  @Input() externalOffers: ExternalOffer[] = [];
  public showOfferData: boolean = false;

  constructor() {
    this.externalOffers = this.externalOffers.filter(offer => offer?.image != null && offer?.image.type);
  }
}
